import useApolloQuery from 'src/hooks/useApolloQuery'

import { FETCH_USER } from 'src/graphql/layout'

export const useLoggedInUser = () => {
  return useApolloQuery(FETCH_USER)
}
